import React from "react";
import { ButtonProps, Confirm, IconButtonWithTooltip, useSimpleFormIteratorItem, useTranslate } from "react-admin";
import CloseIcon from '@mui/icons-material/RemoveCircleOutline';

export const ConfirmRemoveItemButton = (props/*: Omit<ButtonProps, 'onClick'>*/) => {
    const translate = useTranslate();
    const { remove } = useSimpleFormIteratorItem();
    const [confirmIsOpen, setConfirmIsOpen] = React.useState(false);//<boolean>(false);

    const handleConfirm =() => {
        remove();
        setConfirmIsOpen(false);
    };

    return (<React.Fragment>
        <Confirm
            isOpen={confirmIsOpen}
            title={translate(
                'ra.action.remove'
            )}
            content={translate(
                'ra.message.delete_content'
            )}
            onConfirm={handleConfirm}
            onClose={() => setConfirmIsOpen(false)}
        />
        <IconButtonWithTooltip
            label="ra.action.remove"
            size="small"
            onClick={() => setConfirmIsOpen(true)}
            color="warning"
        >
            <CloseIcon fontSize="small" />
        </IconButtonWithTooltip>
    </React.Fragment>);
};
